import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from '../ui/button';

export const Paginator = ({ page, total, pageSize, onPage, testId }) => {
  const pages = Math.max(1, Math.ceil(total / pageSize));
  if (total <= pageSize) return null;
  return (
    <div className="flex items-center justify-between pt-3 text-sm text-[#57534E]" data-testid={testId}>
      <span data-testid={`${testId}-info`}>
        {page * pageSize + 1}–{Math.min(total, (page + 1) * pageSize)} z {total}
      </span>
      <div className="flex items-center gap-2">
        <Button variant="outline" size="sm" disabled={page === 0} onClick={() => onPage(page - 1)} data-testid={`${testId}-prev`}>
          <ChevronLeft className="w-4 h-4" />
        </Button>
        <span className="tabular-nums">{page + 1} / {pages}</span>
        <Button variant="outline" size="sm" disabled={page >= pages - 1} onClick={() => onPage(page + 1)} data-testid={`${testId}-next`}>
          <ChevronRight className="w-4 h-4" />
        </Button>
      </div>
    </div>
  );
};
